<template>
  <main class="about">
    <div class="cv-container">
      <div class="bio-container">
        <h1>
          HEY, I'M SIGNE.
        </h1>
        <p>
          I am a storyteller who wears many hats – I am a video producer, editor and an occasional videographer. I am a journalist at heart and an explorer in thought.
        </p>
        <p>
          My journey here has had many wonderful detours. I started studying journalism and fell in love with video production. I guess that's what living in LA does to you.
        </p>
        <p>
          I began my career at <a target="_blank" href="https://www.attn.com" class="media-link">ATTN:</a>, a digital media company that focuses on social change content that speaks to millennials. It grew from 20 to 150 employees in my time as Senior Producer there and as one of its first video hires, I played a major role in shaping ATTN:'s video voice. My 250+ videos for the brand have generated over 1 billion Facebook views. Best known is the popular web series "<a target="_blank" href="https://www.facebook.com/AmericaVersusbyattn/" class="media-link">America Versus</a>," which I created and developed.
        </p>
        <p>
          Later, at <a target="_blank" href="https://www.scpr.org" class="media-link">KPCC</a>, LA's top NPR station, I created and shaped their visual editorial strategy. As their sole Visual Journalist, I helped grow its audience through visual storytelling.
        </p>
        <p>
          After returning to Europe I joined <a target="_blank" href="https://www.fsparker.ch" class="media-link">FS Parker</a>, a digital agency based in Zurich, and finally stepped my toes into digital marketing and PR. There, I've directed, produced and edited commercial videos for clients such as Siemens Home, Aroma, Vifor Pharma and Swiss Music Awards, helping them engage with target audiences on digital and social platforms.
        </p>
        <p>
          My family and I have since moved to Denmark, where I now run <a target="_blank" href="https://highpitch.cc" class="media-link">highpitch</a>, a small creative studio that helps brands reach the minds and hearts of social-first audiences though video and digital products that cut through the noise.
        </p>
        <p>
          From snappy editorial content to branded video series, I am a versatile producer and editor who works with purpose, empathy, and creativity to bring stories to life.
        </p>
      </div>
      <div class="pic">
        <img src="@/assets/profile1.jpeg"/>
        <ts-button title="LET'S CHAT" style="margin-top: 36px" @click="$router.push('/contact')"/>
      </div>
<!--      <div class="awards-container">-->
<!--        <p class="title">Awards</p>-->
<!--        <ul>-->
<!--          <li v-for="award in awards" :key="award.name">-->
<!--            <p>{{ award.name }}</p>-->
<!--            <a :href="award.link" target="_blank">{{ award.linkName }}</a>-->
<!--          </li>-->
<!--        </ul>-->
<!--      </div>-->
    </div>
  </main>
</template>

<script>
import TSButton from '@/components/TSButton';

export default {
  name: 'About',
  components: {
    'ts-button': TSButton
  },
  data: function () {
    return {
      awards: [
        {
          name: 'WINNER – Edward R. Murrow Award for Excellence in Video, 2020',
          linkName: 'I Hiked Alone In The Sierra Nevada For 14 Days To Prove Myself To Myself',
          link: 'https://laist.com/2019/08/30/i_hiked_alone_in_the_sierra_nevada_for_14_days_to_prove_myself_to_myself.php'
        },
        {
          name: 'FINALIST – Online News Association Award 2015',
          linkName: 'Los Angeles\' Growing Trash Problem Needs New Solutions',
          link: 'http://archive.uscstoryspace.com/2014-2015/signeokl/Capstone/la-trash-dilemma'
        },
        {
          name: 'WINNER – Hollywood Verge Film Awards, Best Documentary Short, 2015',
          linkName: 'Urban Harvest',
          link: 'https://player.vimeo.com/video/127221698'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  display: grid;
  grid-template-columns: 1fr repeat(12, minmax(auto, 60px)) 1fr;
  grid-gap: 40px;
}
.cv-container {
  grid-column: 2 / span 12;
  display: grid;
  grid-template-columns: repeat(12, minmax(auto, 60px));
  grid-gap: 40px;
  min-height: 100px;
  margin-top: 48px;
}
.bio-container {
  grid-column: 1 / span 7;
  text-align: left;
}
.bio-container p {
  line-height: 1.5;
  margin-top: 20px;
}
.media-link {
  text-decoration: none;
  color: #0066B3;
}
.media-link:hover {
  text-decoration: none;
  color: #6DA6F2;
}
.pic {
  grid-column: 9 / span 4;
}
.pic img {
  margin-top: 91px;
  width: 100%;
}
.awards-container {
  grid-row: 2;
  grid-column: 1 / 12;
  text-align: left;
}
.awards-container ul {
  list-style-type: none;
  padding-left: 0;
  margin-right: 40px;
}
.awards-container a {
  text-decoration: none;
  color: #0066B3;
}
.awards-container a:hover {
  text-decoration: none;
  color: #6DA6F2;
}
.title {
  text-align: left;
  font-size: 24px;
  letter-spacing: 4px;
}
@media only screen and (max-width: 1075px) {
  .bio-container {
     grid-column: 1 / span 6;
  }
  .pic {
     grid-column: 8 / span 5;
  }
}
@media only screen and (max-width: 875px) {
  .about {
    grid-template-columns: 40px repeat(6, 1fr) 40px;
    grid-gap: 10px;
  }
  .cv-container {
    grid-column: 2 / span 6;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 20px;
  }
  .bio-container {
    grid-row: 2;
    grid-column: 1 / span 6;
    width: 100%;
  }
  .pic {
    grid-column: 2 / span 4;
    min-width: 260px;;
  }
  .awards-container {
    grid-row: 3;
    grid-column: 1 / span 6;
  }
}
@media only screen and (max-width: 500px) {
  .about {
    grid-template-columns: 10px repeat(6, 1fr) 10px;
    grid-gap: 10px;
  }
  .pic {
    grid-column: 1 / span 6;
    min-width: 260px;;
  }
}
</style>


